import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { getAddress } from "../utils/getAddress";
import { useSelector } from "react-redux";

const useIpAddress = () => {
  const [data, setData] = useState("");
  const { hotCredentials } = useSelector((state) => state.hotCredentials);

  const developerKey = useMemo(() => {
    if (!hotCredentials?.length) return null;

    const idx = hotCredentials.findIndex(
      (credential) => credential.credentialId === "2"
    );
    if (idx === -1) return null;

    return hotCredentials[idx].credentialValue;
  }, [hotCredentials]);

  useEffect(() => {
    axios
      .get("https://geolocation-db.com/json/")
      .then(async (res) => {
        const address = await getAddress({
          lat: res.data.latitude,
          lng: res.data.longitude,
          developerKey,
        });

        setData({ ...res.data, address });
      })
      .catch((err) => console.log(err.message));
  }, []);

  return data;
};

export default useIpAddress;
